/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Invite_NoteInputs */

const en_us2_coaching_invite_note = /** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The email only tells them about the invitation. They accept inside the app, signing in with that same email.`)
};

const pt_br2_coaching_invite_note = /** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O email só avisa do convite. A pessoa aceita dentro do app, entrando com esse mesmo email.`)
};

const pt_pt2_coaching_invite_note = /** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O email só avisa do convite. A pessoa aceita dentro do app, entrando com esse mesmo email.`)
};

/** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */
const es_419_coaching_invite_note = en_us2_coaching_invite_note;

/** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */
const fr_fr2_coaching_invite_note = en_us2_coaching_invite_note;

/** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */
const de_de2_coaching_invite_note = en_us2_coaching_invite_note;

/** @type {(inputs: Coaching_Invite_NoteInputs) => LocalizedString} */
const it_it2_coaching_invite_note = en_us2_coaching_invite_note;

/**
* | output |
* | --- |
* | "The email only tells them about the invitation. They accept inside the app, signing in with that same email." |
*
* @param {Coaching_Invite_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_invite_note = /** @type {((inputs?: Coaching_Invite_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Invite_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_invite_note(inputs)
	if (locale === "es-419") return es_419_coaching_invite_note(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_invite_note(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_invite_note(inputs)
	if (locale === "de-DE") return de_de2_coaching_invite_note(inputs)
	if (locale === "it-IT") return it_it2_coaching_invite_note(inputs)
	return en_us2_coaching_invite_note(inputs)
});
export { coaching_invite_note as "coaching.invite_note" }